import type { ReactElement } from "react";
import type { ProjectContextParams } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";

export function ProjectContextWidget({
  data,
}: WidgetBodyProps<ProjectContextParams>): ReactElement {
  const namedStakeholders = data.stakeholders.filter(
    ({ name }) => name.trim().length > 0,
  ).length;
  const completedOutcomes = data.outcomes.filter(({ filled }) => filled).length;

  return (
    <section className="grid h-full min-h-0 grid-cols-2 gap-3 overflow-auto p-3 text-sm">
      <Summary
        label="Value stream roles"
        value={`${namedStakeholders}/${data.stakeholders.length} named`}
      />
      <Summary
        label="Workshop outcomes"
        value={`${completedOutcomes}/${data.outcomes.length} captured`}
      />
    </section>
  );
}

function Summary({
  label,
  value,
}: {
  readonly label: string;
  readonly value: string;
}): ReactElement {
  return (
    <div className="rounded-md border border-pb-border bg-pb-page p-3">
      <div className="text-dense-1 font-medium text-pb-text-muted">{label}</div>
      <div className="mt-1 text-pb-text">{value}</div>
    </div>
  );
}
